export default function deploymentReducer(state = {}) {
  // read only
  return state;
}
